import { Card, CardBody, Col } from "reactstrap";
import { Ratio } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { RATIO, RATIO_DATA } from "../../../../Data/UiKit/Avatars";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const RatioCart = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={Ratio} span={RATIO_DATA} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            <div className="avatar ratio">
              <Image className="b-r-8 img-100" src={dynamicImage("avtar/11.jpg")} alt="image" />
            </div>
            {RATIO.map(({ className, src }, index) => (
              <div className="avatar ratio" key={index}>
                <Image className={`b-r-8 ${className}`} src={src} alt="image" />
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RatioCart;
